import React, { useEffect, useState, useCallback } from "react";

function MountOnInteraction(props) {
  const { renderUnmounted, renderMounted } = props;
  const [interacted, setInteracted] = useState(false);

  const handleEvent = useCallback(() => {
    setInteracted(true);
  }, []);

  useEffect(() => {
    window.addEventListener("scroll", handleEvent, true);
    window.addEventListener("mousemove", handleEvent, true);
    window.addEventListener("touchstart", handleEvent, true);

    return () => {
      window.removeEventListener("scroll", handleEvent, true);
      window.removeEventListener("mousemove", handleEvent, true);
      window.removeEventListener("touchstart", handleEvent, true);
    };
  }, []);

  useEffect(() => {
    if (interacted) {
      window.removeEventListener("scroll", handleEvent, true);
      window.removeEventListener("mousemove", handleEvent, true);
      window.removeEventListener("touchstart", handleEvent, true);
    }
  }, [interacted]);

  if (!interacted && !renderMounted) {
    return null;
  }

  return (
    <div className={props.className}>
      {!interacted && renderUnmounted?.()}
      {interacted && renderMounted?.()}
    </div>
  );
}

export default MountOnInteraction;
